module.exports = __webpack_public_path__ + "media/images/shark/Shark2-p-1080-32024839c4d5f29b34d4b46ef8ec066e.png";